// src/config/featureFlags.ts
import { isFeatureEnabled } from '@company/shared-utils';

export const FEATURE_FLAGS = {
  SHOW_FASTLEARN_V2: (process.env.VITE_SHOW_FASTLEARN_V2 ?? 'true') === 'true',
  CONTRACTS_V2_ENABLED: (process.env.REACT_APP_CONTRACTS_V2_ENABLED ?? 'true') === 'true',
  // ✅ Product focus: Intelligence Studio is the active surface. Smart Notebook UI is legacy and OFF by default.
  SMART_NOTEBOOK_UI_ENABLED:
    (process.env.REACT_APP_SMART_NOTEBOOK_UI_ENABLED ?? 'false') === 'true',
  IDEAS_KITCHEN_AUDIO_ENABLED:
    (process.env.REACT_APP_IDEAS_KITCHEN_AUDIO_ENABLED ??
      process.env.VITE_IDEAS_KITCHEN_AUDIO_ENABLED ??
      'false') === 'true',
  IDEAS_KITCHEN_DELETE_ENABLED:
    (process.env.REACT_APP_IDEAS_KITCHEN_DELETE_ENABLED ??
      process.env.VITE_IDEAS_KITCHEN_DELETE_ENABLED ??
      'false') === 'true',
  IDEAS_KITCHEN_CLEAR_CHAT_ENABLED:
    (process.env.REACT_APP_IDEAS_KITCHEN_CLEAR_CHAT_ENABLED ??
      process.env.VITE_IDEAS_KITCHEN_CLEAR_CHAT_ENABLED ??
      'false') === 'true',
  IDEAS_KITCHEN_PARTIAL_READY:
    (process.env.REACT_APP_IDEAS_KITCHEN_PARTIAL_READY ??
      process.env.VITE_IDEAS_KITCHEN_PARTIAL_READY ??
      'false') === 'true',
  IDEAS_KITCHEN_SAFETY_BLOCK:
    (process.env.REACT_APP_IDEAS_KITCHEN_SAFETY_BLOCK ??
      process.env.VITE_IDEAS_KITCHEN_SAFETY_BLOCK ??
      'false') === 'true',
  IDEAS_KITCHEN_QUOTA_ENABLED:
    (process.env.REACT_APP_IDEAS_KITCHEN_QUOTA_ENABLED ??
      process.env.VITE_IDEAS_KITCHEN_QUOTA_ENABLED ??
      'false') === 'true',
  IDEAS_KITCHEN_EXPORT_ENABLED:
    (process.env.REACT_APP_IDEAS_KITCHEN_EXPORT_ENABLED ??
      process.env.VITE_IDEAS_KITCHEN_EXPORT_ENABLED ??
      'false') === 'true',
  IDEAS_KITCHEN_LEGAL_HOLD_ENABLED:
    (process.env.REACT_APP_IDEAS_KITCHEN_LEGAL_HOLD_ENABLED ??
      process.env.VITE_IDEAS_KITCHEN_LEGAL_HOLD_ENABLED ??
      'false') === 'true',
} as const;

// Backward compatibility
export const FEATURES = FEATURE_FLAGS;

export const isFeatureEnabledFlag = (flag: keyof typeof FEATURE_FLAGS): boolean => {
  return isFeatureEnabled({ code: String(flag), enabled: FEATURE_FLAGS[flag] }, false);
};
